import { useFormik } from 'formik'
import React, { useState } from 'react'
import ModalComponent from '..'
import { useCreateVariantMutation } from '../../../redux-toolkits/products/products.slice'
import { SingleVariant } from '../../../redux-toolkits/products/products.type'
import { CreateVariantSchema } from '../../../validation/validate'
import { Button } from '../../button'
import { EditInput } from '../../inputs/editInput'

export const CreateVariantModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
  mode: 'edit' | 'create'
  variant?: SingleVariant
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
  mode,
  variant,
}) => {
  const [editIndex, setEditIndex] = useState<number>()

  const [createVariant, { isLoading: creating }] = useCreateVariantMutation()

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: variant?.name ?? '',
      isSubVariant: variant?.isSubVariant ?? false,
    },
    enableReinitialize: true,
    validationSchema: CreateVariantSchema,
    onSubmit: (values) => {
      if (mode === 'create') {
        createVariant(values).then((resp) => {
          if (resp.data?.success) {
            resetForm()
            setOpen(false)
            onSuccessCallback()
          }
        })
      } else if (mode === 'edit' && variant) {
        return
      }
    },
  })
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={mode === 'create' ? 'Add Variant' : 'Edit Variant'}
      childrenClassName="md:!max-w-[420px]"
    >
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <EditInput
          title="Variant name"
          value={values.name}
          onChange={handleChange}
          type="text"
          placeholder="Variant name"
          onEditSave={() => {
            setEditIndex(undefined)
          }}
          editing={editIndex === 1}
          onEditClick={() => {
            setEditIndex(1)
          }}
          onCancel={() => {
            if (mode === 'create') {
              setFieldValue('name', '')
            } else {
              setFieldValue('name', variant?.name)
            }
            setEditIndex(undefined)
          }}
          loading={false}
          inputName="name"
          mode={mode === 'create' ? 'edit' : 'edit'}
        />

        {/* {mode === 'create' && (
          <Checkbox
            checkStatus={values.isSubVariant}
            text="This has sub-variants"
            handleChange={(status) => {
              setFieldValue('isSubVariant', status)
            }}
          />
        )} */}

        <Button
          label="Proceed"
          type="submit"
          className="mt-10"
          disabled={!isValid || creating}
          loading={creating}
          primary
        />
      </form>
    </ModalComponent>
  )
}
